import {Component, ElementRef, Input} from '@angular/core';

@Component({
	selector: 'button-anhor',
	template: `
		<span [class.button-dashed]="isActive()">
			<ng-content></ng-content>
		</span>
	`
})
export class ButtonAnhoreComponent {
	@Input('isActive') _isActive: boolean = true;
	
	constructor(private el: ElementRef) {}
	
	isActive(): boolean {
		const
			button = this.el.nativeElement,
			span   = button.querySelector('span'),
			val    = span ? span.textContent.trim(): button.textContent.trim();
		
		return this._isActive && val !== '0';
	}
}
